__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/0f3a752/_next/";